<template>
  <div>
    <div style="position: fixed;top:0;z-index:999999;width: 100%;height: 1rem;background-color: white">
      <div style="width: 90%;margin-left: 5%">
        <md-input-item
          ref="input11"
          v-model="keyword"
          @blur="getlist(null)"
          placeholder="訂單號、 國內快遞單號">
          <md-icon name="search" slot="left" @click.native="getlist(null)"></md-icon>
          <span slot="right" @click="cancel">取消</span>
        </md-input-item>
      </div>
    </div>
    <div style="width: 100%;height: 1rem"></div>
    <v-refresh :on-refresh="onRefreshone">
      <v-reload
        :on-infinite-load="infinite"
        :parent-pull-up-state="infiniteLoadData.pullUpState"
      >
        <div v-if="list.length>0" class="packcontainer">
            <div v-for="(item,index) in list" :key="index" class="packItem">
              <div class="packcompany">
                <div class="packtitle" @click.stop="copy(item.code)">
                  訂單號：{{ item.code }}
                  <img src="@/assets/image/copy.png" alt="" style="margin-left: 0.2rem">
                </div>
              </div>
              <div class="pckdetail" @click="godetail(item)">
                <div class="toptitle">
                  <div class="tpleft">
                    <div class="iconbe teicon" v-if="item.transportWay=='1'">
                      <span>特貨</span>
                    </div>
                    <div class="iconbe" v-else>
                      <span>普貨</span>
                    </div>
                    <span style="margin-left: 0.05rem">{{ item.transCode }}</span>
                  </div>
                  <div class="tpcenter">
                    <span>{{ item.weight }}KG</span>
                  </div>
                  <div class="tpcenright">
                  </div>
                </div>
                <div class="toptitle">
                  <div class="tpleft alcenetr">
                    <span style="font-size: 0.4rem;font-weight: bold">{{item.sendCountry}}</span>
                  </div>
                  <div class="tpcenter">
                    <img src="@/assets/image/link.png" alt="">
                  </div>
                  <div class="tpcenright">
                    <span style="font-size: 0.4rem;font-weight: bold">{{ item.countryName }}</span>
                  </div>
                </div>
                <div class="toptitle" style="margin-bottom: 0.3rem">
                  <div class="tpleft alcenetr">
                    <span style="font-size: 0.32rem;">{{ item.warehouse }}</span>
                  </div>
                  <div class="tpcenter">
                    <span v-if="item.status==1" style="color: #BB291D">待付款</span>
                    <span v-if="item.status==2">待收貨</span>
                    <span v-if="item.status==3" style="color: #e51c23">已完成</span>
                    <span v-if="item.status==4" style="color: #BB291D">已取消</span>
                    <span v-if="item.status==5" style="color: #32c5ea">退款中</span>
                  </div>
                  <div class="tpcenright">
                    <span style="font-size: 0.32rem;">{{ item.name }}</span>
                  </div>
                </div>
                <p v-if="item.status==2||item.status==3" style="text-align: left">付款時間：<span style="margin-left: -0.05rem">{{item.updateTime|dateformat('YYYY-MM-DD HH:mm')}}</span></p>
              </div>
              <div style="width: 100%;height: 0.2rem"></div>
              <div class="packopeartion" v-if="item.status==1" style="margin-top: -0.4rem">
                <div class="paymintci">
                  <span style="font-size: 0.4rem;">需支付¥<md-amount :value="item.totalPrice" has-separator></md-amount></span>
                </div>
                <md-button type="default" size="small" inline plain @click="delet(item)" round>取消</md-button>
                <md-button type="primary" size="small" inline plain style="margin:0 0.2rem" @click="parpries(item)"
                           round>去付款
                </md-button>
              </div>
              <div v-if="item.trackInfo"
                   style="background-color: rgb(242,242,242);margin-bottom:0.4rem;display: flex;flex-direction:column;align-items:
                      flex-start">
                <div style="display: flex;justify-content: space-between;width: 100%;padding: 0.2rem">
                  <md-button type="primary" size="small" inline plain>{{ item.trackInfo }}
                  </md-button>
                  <span style="font-size: 0.3rem;padding-right: 0.5rem">{{ item.trackDetail.eventtime }}</span>
                </div>
                <p style="font-size: 0.32rem;padding:0 0.2rem 0.2rem 0.2rem;text-align: left;line-height: 0.5rem">
                  {{ item.trackDetail.eventscan }}</p>
              </div>
              <div class="packopeartion" v-if="item.status==2||item.status==3" style="margin-top: -0.4rem">
                <md-button type="default" size="small" inline plain @click="look(item)" round
                           style="margin-right: 0.2rem">查看物流
                </md-button>
              </div>
            </div>
          </div>
        <noth-modal v-else></noth-modal>
        <div style="width: 100%;height: 2rem"></div>
      </v-reload>
    </v-refresh>
  </div>
</template>

<script>
import { Amount, Button, Dialog, Field, Icon, InputItem, TabPane, Tabs, Toast } from 'mand-mobile'
import DropDownRefresh from '../../components/refresh'
import PullUpReload from '../../components/pullDown'
import NothModal from '../Modal/NothModal'

export default {
  name: 'packSearch',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [Amount.name]: Amount,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    // eslint-disable-next-line vue/no-unused-components
    'v-refresh': DropDownRefresh,
    // eslint-disable-next-line vue/no-unused-components
    'v-reload': PullUpReload,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data () {
    return {
      infiniteLoadData: {
        initialShowNum: 5, // 初始显示多少条
        everyLoadingNum: 5, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },
      pagenum: 1,
      keyword: '',
      list: []
    }
  },
  activated () {
    if (localStorage.getItem('serorder')) {

    } else {
      this.list = []
      this.pagenum = []
      this.keyword = ''
      this.infiniteLoadData.pullUpState = 0
      this.infiniteLoadData.pullUpList = []
    }
  },
  methods: {
    cancel(){
      this.keyword=''
      this.$router.go(-1)
    },
    look (item) {
      this.$router.push({
        name: 'OrderLogin',
        query: {
          des: JSON.stringify(item)
        }
      })
    },
    getvalue () {
      console.log(this.keyword)
    },
    getlist (opear) {
      this.infiniteLoadData.pullUpState = 2
      const par = {
        keyword: this.keyword,
        pageNum: this.pagenum,
        pageSize: 5,
        sort: false
      }
      this.http.APIASK(this.ports.ordersearch, 'get', par).then(res => {
        if (opear) {
          if (res.list.length > 0) {
            this.list = this.list.concat(res.list)
            this.infiniteLoadData.pullUpList = this.list
            if (res.list.length < 5) {
              this.infiniteLoadData.pullUpState = 3
            } else {
              this.infiniteLoadData.pullUpState = 1
            }
          } else {
            this.infiniteLoadData.pullUpState = 3
          }
        } else {
          if (res.list.length < 5) {
            this.infiniteLoadData.pullUpState = 3
          } else {
            this.infiniteLoadData.pullUpState = 1
          }
          this.list = res.list
          this.infiniteLoadData.pullUpList = this.list
        }
        this.list.length < 3 ? this.infiniteLoadData.pullUpState = 0 : null
        Toast.hide()
      }).catch(err => {
        Toast.hide()
      })
    },
    delet (item) {
      const itemvale=JSON.parse(localStorage.getItem('countryList')).filter(val=>{
        return val.id==item.countryId
      })
      Dialog.confirm({
        title: '確認要取消這個訂單嗎？',
        content: itemvale[0].code=='TW'?'商超支付非即时入帐，存在2~3天延迟，如您已实际支付订单请不要取消订单，以免造成不便':'訂單取消後，您可以在已入庫包裹中重新合單',
        confirmText: '確定',
        onConfirm: () => {
          const par = {
            id: item.id
          }
          this.http.APIASK(this.ports.ordercancel, 'get', par).then(res => {
            this.getlist(null)
            localStorage.setItem('fleshpack', 1)
            localStorage.setItem('fleshorder', 1)
            Toast.succeed('取消成功')
          }).catch(err => {
          })
        }
      })
    },
    godetail (item) {
      localStorage.setItem('serorder', 1)
      this.$router.push({ name: 'OrderDetail', query: { id: item.id } })
    },
    onRefreshone (done) {
      setTimeout(() => {
        this.infiniteLoadData.pullUpList = []
        this.pagenum = 1
        this.getlist(null)
        done()
      }, 500)
    },
    onClick () {

    },
    copy(name) {
      const url = name
      const oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.remove()
      Toast.succeed('複製成功')
    },
    infinite (done) {
      console.log(this.infiniteLoadData.pullUpState)
      if (this.infiniteLoadData.pullUpState === 1) {
        setTimeout(() => {
          this.pagenum++
          this.getlist('load')
          done()
        }, 500)
      } else {
        this.infiniteLoadData.pullUpState = 0
      }
      done()
    }
  }
}
</script>

<style lang="less">
  .packcontainer{
    margin-top: 0.2rem;
  }
  .packItem {
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
    margin-bottom: 0.2rem;
    border-radius: 0.1rem;
    width: 96%;
    margin-left: 2%;

    .packcompany {
      width: 100%;
      height: 0.8rem;
      display: flex;
      align-items: center;
      font-size: 0.26rem;
      justify-content: space-between;
      border: none;

      .packtitle {
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 0.2rem;
        color: #888888;

        img {
          width: 0.5rem;
          margin: 0 0.2rem;
        }
      }

      span {
        margin-right: 0.2rem;
      }
    }

    .pckdetail {
      width: 100%;
      padding-left: 0.2rem;
      font-size: 0.3rem;
      position: relative;

      .toptitle {
        width: 100%;
        display: flex;
        align-items: center;

        .tpleft {
          width: 60%;
          display: flex;
          align-items: center;
          font-size: 0.28rem;
          .iconbe {
            padding: 0.04rem 0.06rem;
            background-color: rgb(48, 125, 253);
            color: white;
            border-radius: 0.05rem;
          }

          .teicon {
            background-color: rgb(82, 204, 111);
          }
        }

        .alcenetr {
          justify-content: center;
          margin-top: 0.2rem;
        }

        .tpcenter {
          width: 30%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .tpcenright {
          width: 40%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .packopeartion {
      width: 100%;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .paymintci{
        display: flex;
        align-items: center;
        min-width: 58%;
        font-size: 0.45rem;
        color: #BB291D;
      }
    }
  }

  .packageTyp {
    padding: 0.04rem 0.11rem;
    border-radius: 0.07rem;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(82, 204, 111, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.2rem;

    span {
      margin: 0 !important;
    }
  }

  .checkbtn {
    margin-left: 0.2rem;

    .md-check-icon {
      font-size: 0.8rem;
    }
  }

  .bottomView {
    position: fixed;
    width: 100%;
    height: 1rem;
    bottom: 1rem;
    margin-bottom: 0.2rem;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .checkall {
      height: 100%;
      display: flex;
      align-items: center;
      width: 20%;
      margin-left: 4%;

      span {
        margin-left: 0.1rem;
        font-size: 0.32rem;
      }
    }

    .chelist {
      width: 74%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .cancle {
      font-size: 0.32rem;

      p {
        span {
          color: #e51c23;
          margin-right: 0.2rem;
        }
      }

    }
  }
</style>
